/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { pixiesetAPIBaseURIs, pixiesetSubdomains } from "@/utils/pixieset-urls"
import { QueryClient } from "@tanstack/query-core"

export const pnApiBaseUri: string =
	import.meta.env.VITE_POLARR_NEXT_API_BASE_URI ?? "https://api.staging.polarr.co/polarr-next/"

const optionalEnvString = (value: unknown): string | undefined => {
	if (typeof value !== "string") {
		return undefined
	}

	const trimmed = value.trim()
	return trimmed ? trimmed : undefined
}

export const photoEditorMaintenanceStatusUrl = optionalEnvString(
	import.meta.env.VITE_PHOTO_EDITOR_MAINTENANCE_STATUS_URL,
)

export const psApiBaseUri: string = pixiesetAPIBaseURIs.galleries
export const queryClient = new QueryClient()

export const auth0Domain: string = import.meta.env.VITE_AUTH0_DOMAIN ?? "auth.polarr.com"
export const auth0ClientId: string =
	import.meta.env.VITE_AUTH0_CLIENT_ID ?? "UDZKxzTPzbvkxQVbmijlMEneem7t7klY"
export const auth0Audience: string =
	import.meta.env.VITE_AUTH0_AUDIENCE ?? "https://api.staging.polarr.co/polarr-next/"

export const psImageBaseUri: string = pixiesetAPIBaseURIs.images

export const psGalleryBaseUri: string = pixiesetSubdomains.gallery
export const psGalleriesBaseUri: string = pixiesetSubdomains.galleries
export const psHelpCenterUri: string = pixiesetAPIBaseURIs.services
